import React from 'react'

const ActionCardComponent = ({ children }) => {
  const childArray = React.Children.toArray(children)

  const leftChildren = childArray.filter(
    child => child?.props?.['data-align'] === 'left'
  )

  const rightChildren = childArray.filter(
    child => child?.props?.['data-align'] !== 'left'
  )

  return (
    <div className='flex flex-col md:flex-row justify-between items-center border-t border-l border-r border-gray-200 bg-gray-50 p-4 rounded-t-lg gap-4'>

      <div className='flex items-center gap-4'>
        {leftChildren}
      </div>
      <div className='flex flex-wrap justify-end gap-4 ml-auto'>
        {rightChildren}
      </div>
    </div>
  )
}

export default ActionCardComponent
